import React from "react";
import {
  Card,
  CardContent,
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Stack,
} from "@mui/material";
import NoData from "components/NoData";
import dayjs from "dayjs";
import { I18n } from "@aws-amplify/core";
import useMediaQuery from "@mui/material/useMediaQuery";

const formatTimestamp = (timestamp) => dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");

const StoreCard = ({ data }) => {
  const isMobileDevice = useMediaQuery("(max-width:600px)");

  const headerCellsStore = [
    { id: "store_name", label: I18n.get("Store Name"), align: "left", flex: 1 ,},
    { id: "store_management", label: I18n.get("Store Management"), align: "left", flex: 1 },
    { id: "tlm_active", label: I18n.get("TLM Active"), align: "left", flex: 1 },
    { id: "tls_activation_date", label: I18n.get("Activation Date"), align: "left", flex: 1, renderCell: (value) => formatTimestamp(value) },
    { id: "tls_contract_start_date", label: I18n.get("Contract Start Date"), align: "left", flex: 1, renderCell: (value) => formatTimestamp(value) },
    { id: "tls_contract_end_date", label: I18n.get("Contract End Date"), align: "left", flex: 1, renderCell: (value) => formatTimestamp(value) },
    { id: "tls_contract_type", label: I18n.get("Contract Type"), align: "left", flex: 1 },
  ];

  if (!data || Object.keys(data).length === 0) {
    return (
      <Card >
        <CardContent sx={{ padding: "1rem", "&:last-child":{padding:"1rem 0"} }}>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ pb: 2 }}
          >
            <Typography variant="h5">{I18n.get("Stores")}</Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{marginBottom:"1rem"}}>
      <CardContent sx={{ "&:last-child":{padding:"1rem"} }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ pb: 2 }}
        >
          <Typography variant="h5">{I18n.get("Telemonitoring Contract Information")}</Typography>
        </Stack>
        <TableContainer>
          <Table>
            <TableBody>
              {headerCellsStore.map((column, colIndex) => (
                <React.Fragment key={colIndex}>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      padding: "0px",
                      borderBottom: "1px solid #e0e0e0",
                      fontSize: "14px",
                      lineHeight: 1.6,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {column.label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      {data[column.id] !== undefined && data[column.id] !== null
                        ? column.renderCell
                          ? column.renderCell(data[column.id])
                          : data[column.id]
                        : ""}
                    </Typography>
                  </TableCell>
                  {(colIndex + 1) % (isMobileDevice ? 1 : 2) === 0 && (
                    <TableRow key={`spacer-${colIndex}`}></TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default StoreCard;
